/**
  Dui
  xl
  font: 18px
  line: 26px
  1.44444444

  lg
  font: 16px
  line: 24px
  1.5

  md
  font: 16px
  line: 24px
  1.5

  sm
  font: 14px
  line: 20px
  1.42857142857
 */
export function getLineHeight(fontSize) {
  // Dui start
  if (fontSize === 14) {
    return (fontSize + 6) / fontSize;
  }
  // Dui end
  return (fontSize + 8) / fontSize;
}
// https://zhuanlan.zhihu.com/p/32746810
export default function getFontSizes(base) {
  const fontSizes = new Array(10).fill(null).map((_, index) => {
    const i = index - 1;
    const baseSize = base * Math.pow(2.71828, i / 5);
    const intSize = index > 1 ? Math.floor(baseSize) : Math.ceil(baseSize);
    // Convert to even
    return Math.floor(intSize / 2) * 2;
  });
  fontSizes[1] = base;
  return fontSizes.map(size => ({
    size,
    lineHeight: getLineHeight(size)
  }));
}